import {
  type TReasonDictionary,
  type TReasonDictionaryApi,
  type TReasonDictionaryDto,
  type TReasonDictionaryForm
} from '@/components/AdminPanel/Directory/types/reasons.types';
import { convertActiveStatus } from '@/components/AdminPanel/Shared/helpers/convertActiveStatus';

export const reasonsDirectoryMapperFromApi = (
  reason: TReasonDictionaryApi
): TReasonDictionary => {
  return {
    code: reason.code,
    isActive: convertActiveStatus.toStr(reason.is_active),
    name: reason.name,
    type: reason.type,
    uuid: reason.uuid
  };
};

export const reasonsDirectoryMapperToDto = (
  reason: TReasonDictionaryForm
): TReasonDictionaryDto => {
  return {
    code: reason.code,
    is_active: convertActiveStatus.toBoolean(reason.isActive),
    name: reason.name,
    type: reason.type,
    uuid: reason.uuid
  };
};
